import { motion } from "framer-motion";
import { Crown } from "lucide-react";

const offsets = ["md:mt-0", "md:mt-16", "md:mt-8", "md:mt-24"];

export const Gallery = () => (
  <section
    id="gallery"
    data-testid="gallery-section"
    className="border-y border-white/10 bg-[#0b0b0b] py-28 md:py-40"
  >
    <div className="mx-auto max-w-7xl px-6">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="mb-16 md:mb-24"
      >
        <p className="font-accent mb-4 text-xs font-semibold tracking-[0.4em] text-[#D4AF37]">
          A GLIMPSE OF THE KINGDOM
        </p>
        <h2 className="font-display max-w-xl text-4xl font-semibold tracking-tight text-[#EAEAEA] md:text-6xl">
          Straight from the battlefield.
        </h2>
        <p className="mt-6 text-sm text-[#A3A3A3] md:text-base">
          Screenshots coming soon.
        </p>
      </motion.div>

      <div className="grid grid-cols-2 gap-6 md:grid-cols-4 md:gap-8">
        {offsets.map((offset, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{
              duration: 0.9,
              delay: i * 0.12,
              ease: [0.22, 1, 0.36, 1],
            }}
            data-testid={`gallery-shot-${i + 1}`}
            className={`group ${offset}`}
          >
            <div className="relative aspect-[9/19] overflow-hidden rounded-[2rem] border border-white/10 bg-gradient-to-b from-[#15170f] to-[#0b0b0b] shadow-[0_20px_60px_rgba(0,0,0,0.6)] transition-colors duration-500 group-hover:border-[#D4AF37]/40">
              <div className="absolute left-1/2 top-3 h-5 w-20 -translate-x-1/2 rounded-full bg-black/80" />
              <div className="absolute inset-0 flex flex-col items-center justify-center gap-4 px-4 text-center">
                <Crown className="h-8 w-8 text-[#D4AF37]/50 transition-colors duration-500 group-hover:text-[#D4AF37]" />
                <p className="font-accent text-[10px] font-semibold tracking-[0.3em] text-[#737373]">
                  SCREENSHOT
                  <br />
                  COMING SOON
                </p>
              </div>
              <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(212,175,55,0.08),transparent_60%)]" />
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
